import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import NextComponent from "./NextComponent";
import Landing from "./agent/Landing";
import usePageView from "../../hooks/usePageView";

export default function ScrollLandingPage() {
  usePageView("/landing");
  const theme = useTheme();
  const [scrollSpeed, setScrollSpeed] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      const goingDown = e.deltaY > 30;
      const goingUp = e.deltaY < -30;

      setScrollSpeed(Math.min(Math.abs(e.deltaY), 20));

      if (!scrolled && goingDown) {
        setScrolled(true);
      } else if (scrolled && goingUp) {
        setScrolled(false);
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: true });
    return () => window.removeEventListener("wheel", handleWheel);
  }, [scrolled]);

  useEffect(() => {
    const interval = setInterval(() => {
      setScrollSpeed((s) => Math.max(0, s - 0.5));
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden", // ← This hides scroll bar
        position: "relative",
      }}
    >
      <Box
        sx={{
          height: "200vh", // contains both sections
          transform: `translateY(${scrolled ? "-100vh" : "0"})`,
          transition: "transform 0.7s ease-in-out",
        }}
      >
        <Box sx={{ height: "100vh" }}>
          <Landing scrollSpeed={scrollSpeed} />
        </Box>
        <Box
          sx={{
            height: "100vh",
            backgroundColor: theme.palette.grey[200],
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <NextComponent />
        </Box>
      </Box>
    </Box>
  );
}
